import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MdMenuOpen, MdOutlineMenu } from 'react-icons/md';
import { CiLight } from 'react-icons/ci';
import { FaWallet, FaBell, FaMoon } from 'react-icons/fa';
import { CgSearch } from "react-icons/cg";
import { useMyContext } from '../../../context/MyContext';
import { toast } from 'react-hot-toast'
import { useAuth } from '../../../routes/Auth';
import {
  Base_Url,
  userdata,
  Url_For_View_Document,
  readnotification,
  forwardorderlistall,
  payment,
  notification,
  grandTotalAmount
} from '../../../config/config';

const NavBar = () => {
  const {
    isB2BMode,
    setIsToggleSidebar,
    toggleB2BMode,
    isToggleSidebar,
    isDarkMode,
    toggleTheme,
    setorderId,
    setIsDarkMode } = useMyContext();
  const navigate = useNavigate();
  const notificationMenuRef = useRef(null);
  const [walletMenuVisible, setWalletMenuVisible] = useState(false);
  const walletMenuRef = useRef(null);
  const [isSearching, setIsSearching] = useState(false);
  const userMenuRef = useRef(null);
  const [userData, setUserData] = useState([]);
  const [userName, setUserName] = useState("");
  const [userMenu, setUserMenu] = useState(false);
  const { logout } = useAuth()
  const user = JSON.parse(localStorage.getItem('user'));
  const [orderIdInput, setOrderIdInput] = useState('');
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const role = localStorage.getItem('role');
  const [profile, setProfile] = useState()
  const [notificationMenuVisible, setNotificationMenuVisible] = useState(false);
  const [currentBalanace, setCurrentBalanace] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  // const [isB2B, setIsB2B] = useState(true);
  const [totalAmount, setTotalAmount] = useState(0);
  const profile_flag = localStorage.getItem('profile_flag');


  useEffect(() => {

    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser && storedUser.userData.name) {
      setUserName(storedUser.userData.name);
    }
    if (role === "admin") {
      getTotalAmount();
    }
    getPayment();
  }, []);

  useEffect(() => {
    fetchUserData();
    fetchNotifications();
  }, [cus_id, token]);

  const fetchNotifications = async () => {
    const url = Base_Url + notification;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cus_id,
          'Content-Type': 'application/json',
        },
      });
      const result = await response.json();

      if (result.status === "SUCCESS") {
        setNotifications(result.data);
        const unread = result.data.filter(notif => notif.is_read === "0").length;
        setUnreadCount(unread);
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  const fetchUserData = async () => {
    const url = Base_Url + userdata;
    if (cus_id) {
      try {
        const response = await fetch(url + "/" + cus_id, {
          method: 'GET',
          headers: {
            'token': token,
            'cus_id': cus_id,
            'Content-Type': 'application/json',
          },
        });
        const result = await response.json();
        // console.log(result  ); debugger;
        setUserData(result.data);
        const profile = result.data.profile_image
          ? Url_For_View_Document + result.data.profile_image
          : null;
        setProfile(profile);
        if (result.data.name) {
          setUserName(result.data.name);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    }
  };

  const toggleWalletMenu = () => {
    const walletStatus = user.userData.wallet_status;

    if (walletStatus === "1") {
      setWalletMenuVisible(!walletMenuVisible);
    }
  };

  const toggleNotificationMenu = () => {
    setNotificationMenuVisible(!notificationMenuVisible);
  };

  const toggleUserMenu = () => {
    setUserMenu(!userMenu);
  }

  const goToTopUp = () => {
    navigate('/payments/walletbalance');
  };

  const navigation = () => {
    if (profile_flag === "1") {
      navigate('/profile');
    }
  }

  const handleLogout = () => {
    localStorage.removeItem("user");
    document.documentElement.classList.remove('dark');
    setIsDarkMode(false);
    navigate('/login')
    logout()
    localStorage.removeItem('cus_id')
    localStorage.removeItem('token')
    localStorage.removeItem("wallet_status");
    localStorage.removeItem("profile_flag");
    localStorage.removeItem("role");
    localStorage.removeItem("isB2BMode");
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (walletMenuRef.current && !walletMenuRef.current.contains(event.target)) {
        setWalletMenuVisible(false);
      }
      else if (notificationMenuRef.current && !notificationMenuRef.current.contains(event.target)) {
        setNotificationMenuVisible(false);
        handleDeleteNotification();
        fetchNotifications();
      }
      else if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setUserMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [walletMenuRef, userMenuRef, notificationMenuRef, setWalletMenuVisible, setNotificationMenuVisible, setUserMenu]);


  const handleSearchKeyDown = async (event) => {
    if (event.key === 'Enter') {
      const trimmedInput = orderIdInput.trim();
      if (!trimmedInput) {
        toast.error('Please enter a valid Order ID');
        return;
      }
      setIsSearching(true);
      setorderId(trimmedInput);
      setTimeout(() => navigate('/shipments/tracking'), 100);
      setIsSearching(false);

    }
  };


  const handleDeleteNotification = async () => {
    const urldelete = Base_Url + readnotification;

    try {
      const token = localStorage.getItem('token');
      const cusid = localStorage.getItem('cus_id');

      const response = await fetch(urldelete, {
        method: "GET",
        headers: {
          "token": token,
          "cus_id": cusid,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (data.status === "SUCCESS") {
      } else {
      }
    } catch (error) {
    }
  };

  const getPayment = async () => {
    const url = Base_Url + payment
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "success") {
        setCurrentBalanace(data.totalamount);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };


  const getTotalAmount = async () => {
    const uri = Base_Url + "admin/" + grandTotalAmount;

    try {
      const token = localStorage.getItem('token');
      const cusid = localStorage.getItem('cus_id');

      const response = await fetch(uri, {
        method: "GET",
        headers: {
          "token": token,
          "cus_id": cusid,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      if (data.status === "SUCCESS") {
        // setTotalAmount(parseFloat(data.grand_total).toFixed(2)); 
        setTotalAmount(data.grand_total);
      } else {
        console.error("Error:", data);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };


  const NotificationMenu = () => (
    <div
      ref={notificationMenuRef}
      className="absolute right-0 mt-4 w-80 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-96 overflow-y-auto"
    >
      <div className="p-4 border-b border-gray-200 dark:border-gray-700">
        <h3 className="text-lg font-semibold dark:text-white">Notifications</h3>
      </div>
      {notifications.length === 0 ? (
        <div className="p-4 text-center text-gray-500 dark:text-gray-400">
          No notifications
        </div>
      ) : (
        <ul className="divide-y divide-gray-200 dark:divide-gray-700">
          {notifications.map((notification) => (
            <li
              key={notification.id}
              className={`p-4 hover:bg-gray-50 dark:hover:bg-purple-700 transition-colors duration-200 cursor-pointer ${notification.is_read === "0" ? 'bg-blue-50 dark:bg-blue-900/20' : ''
                }`}
            // onClick={() => markAsRead(notification.id)}
            >
              <div className="flex flex-col">
                <span className="font-semibold text-sm dark:text-white">
                  {notification.title}
                </span>
                <span className="text-sm text-gray-600 dark:text-gray-300">
                  {notification.message}
                </span>
                <span className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                  {new Date(notification.created_at).toLocaleString()}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );

  const handleInputChange = (event) => {
    const { value, id } = event.target;
    if (['orderId'].includes(id)) {
      const filteredValue = value.replace(/[^0-9]/g, '');
      event.target.value = filteredValue;
      setOrderIdInput(filteredValue);

    }
  };


  const SwitchIcon = ({ isOn, onToggle }) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="42"
        height="24"
        viewBox="0 0 40 22"
        onClick={onToggle}  // 🔥 call switchToB2B when clicked
        className="cursor-poniter transition-colors duration-300"
      >
        {/* Background Bar */}
        <rect
          x="1"
          y="1"
          rx="11"
          ry="11"
          width="38"
          height="20"
          className={`transition-colors duration-300 ${isOn ? "fill-blue-500" : "fill-gray-400"
            }`}
        />

        {/* B2C Text - only show when switch is off (gray) */}
        {!isOn && (
          <text
            x="29"
            y="12"
            textAnchor="middle"
            dominantBaseline="middle"
            className="fill-white text-xs font-medium pointer-events-none select-none"
            style={{ fontSize: '7px' }}
          >
            B2C
          </text>
        )}

        {/* Circle Knob */}
        <circle
          cx={isOn ? "29" : "11"}
          cy="11"
          r="8"
          className="fill-white transition-all duration-300"
        />
      </svg>
    );
  };

  const switchToB2B = () => {
    // Toggle B2B mode in the context
    toggleB2BMode(!isB2BMode);

    // Navigate to the appropriate dashboard
    if (!isB2BMode) {
      navigate("/b2b/dashboard");
      window.location.reload();
    } else {
      navigate("/dashboard");
    }
  };
  return (
    <div className="flex flex-wrap items-center justify-between px-4 py-2 md:py-0 relative bg-white dark:bg-gray-900">
      <div className="flex items-center">
        <Link to="/dashboard">
          <div className="flex items-center cursor-pointer pl-0 md:pl-0">
            <img src="/assets/images/logo1.png" alt="Logo" className="w-[60px] h-[40px] sm:w-[120px] sm:h-[50px] lg:w-[190px] lg:h-[100px]" />
          </div>
        </Link>
        <button
          onClick={() => setIsToggleSidebar(!isToggleSidebar)}
          className="ml-7 md:ml-10 text-blue-500 dark:text-blue-400"
        >
          {/* {isToggleSidebar === false ? <MdMenuOpen size={28}
            className={`transform transition-transform duration-200 group-hover:scale-110 ${isDarkMode ? "text-white" : "bg-white"}`} /> : <MdOutlineMenu size={28}
              className={`transform transition-transform duration-200 group-hover:scale-110 ${isDarkMode ? "text-white" : "bg-white"}`} />} */}
          {isToggleSidebar === false ? <MdMenuOpen size={20} className=" w-8 sm:w-10 sm:h-10" /> : <MdOutlineMenu size={20} className="sm:w-10 sm:h-10" />}
        </button>
      </div>

      <div className="flex items-center space-x-1 lg:space-x-8 lg:pr-12 pr-3 order-2 md:order-3 relative">
        <div className="relative group">
          <div className="relative">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="60"
              height="32"
              viewBox="0 0 60 32"
              onClick={switchToB2B}
              className="cursor-pointer transition-all duration-300 hover:scale-105 filter hover:drop-shadow-lg"
            >
              {/* Background Bar with Gradient */}
              <defs>
                <linearGradient id="onGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style={{ stopColor: '#3B82F6', stopOpacity: 1 }} />
                  <stop offset="100%" style={{ stopColor: '#1D4ED8', stopOpacity: 1 }} />
                </linearGradient>
                <linearGradient id="offGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style={{ stopColor: '#9CA3AF', stopOpacity: 1 }} />
                  <stop offset="100%" style={{ stopColor: '#6B7280', stopOpacity: 1 }} />
                </linearGradient>
              </defs>

              <rect
                x="2"
                y="2"
                rx="14"
                ry="14"
                width="56"
                height="28"
                fill={isB2BMode ? "url(#onGradient)" : "#E5E7EB"} // light gray (#E5E7EB = Tailwind gray-200)
                className="transition-all duration-300"
              />

              {/* B2C Text - show when OFF */}
              {!isB2BMode && (
                <text
                  x="42"
                  y="17"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  className="font-bold pointer-events-none select-none"
                  style={{ fontSize: '10px', fontFamily: 'system-ui', fill: '#60A5FA' }} // blue-400
                >
                  B2C
                </text>
              )}
              {/* B2B Text - show when ON */}
              {isB2BMode && (
                <text
                  x="18"
                  y="17"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  className="fill-white font-bold pointer-events-none select-none"
                  style={{ fontSize: '10px', fontFamily: 'system-ui' }}
                >
                  B2B
                </text>
              )}

              {/* Circle Knob with Shadow */}
              <circle
                cx={isB2BMode ? "44" : "16"}
                cy="16"
                r="11"
                className="fill-white transition-all duration-300 filter drop-shadow-md"
              />

              {/* Inner circle for depth */}
              <circle
                cx={isB2BMode ? "44" : "16"}
                cy="16"
                r="8"
                className="fill-white transition-all duration-300"
              />
            </svg>
          </div>

          {/* Tooltip */}
          <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 text-xs bg-gray-800 text-white dark:bg-white dark:text-black px-3 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-50">
            {isB2BMode ? "Switch to B2C" : "Switch to B2B"}
          </span>
        </div>

        {/* Theme Toggle Button */}
        <div className="relative group">
          <button
            onClick={toggleTheme}
            className="w-10 h-10 flex items-center justify-center rounded-full transition-all duration-300 hover:bg-gray-100 dark:hover:bg-gray-700 hover:scale-105 focus:outline-none"
          >
            {isDarkMode ?
              <CiLight size={24} className="text-white transition-colors duration-300" /> :
              <FaMoon size={24} className="text-blue-500 transition-colors duration-300" />
            }
          </button>
          <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 text-xs bg-gray-800 text-white dark:bg-white dark:text-black px-3 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-50">
            {isDarkMode ? "Light Mode" : "Dark Mode"}
          </span>
        </div>

        {/* Wallet Button */}
        <div className="relative group">
          <button
            onClick={toggleWalletMenu}
            className="w-10 h-10 flex items-center justify-center rounded-full transition-all duration-300 hover:bg-gray-100 dark:hover:bg-gray-700 hover:scale-105 focus:outline-none"
            aria-label="Toggle wallet menu"
          >
            <FaWallet size={24} className={`transition-colors duration-300 ${isDarkMode ? "text-white" : "text-blue-500"}`} />
          </button>

          {/* Wallet Menu */}
          {walletMenuVisible && (
            <div
              ref={walletMenuRef}
              className="absolute right-0 mt-4 w-56 bg-white dark:bg-[#071a74f6] border border-gray-200 rounded-lg shadow-lg z-50 transition-all duration-200 ease-in-out overflow-hidden"
            >
              <ul className="text-gray-700 dark:text-gray-200 dark:shadow-custom-dark divide-y divide-gray-200 dark:divide-gray-700">
                <li className="py-2 px-4 cursor-default flex items-center justify-between">
                  <span>Balance</span>
                  {role !== "admin" ? (
                    <span className="font-semibold">₹ {currentBalanace}</span>
                  ) : (
                    <span className="font-semibold">₹ {totalAmount}</span>
                  )}
                </li>
                <li
                  className="py-2 px-4 cursor-pointer hover:bg-gray-100 hover:dark:bg-purple-700 transition-colors duration-200 flex items-center justify-between"
                  onClick={goToTopUp}
                >
                  <span>Top-Up</span>
                  <span className="text-gray-400">|</span>
                </li>
              </ul>
            </div>
          )}
          <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 text-xs bg-gray-800 text-white dark:bg-white dark:text-black px-3 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-50">
            Wallet
          </span>
        </div>

        {/* Notification Button */}
        <div className="relative group">
          <button
            onClick={toggleNotificationMenu}
            className="w-10 h-10 flex items-center justify-center rounded-full transition-all duration-300 hover:bg-gray-100 dark:hover:bg-gray-700 hover:scale-105 focus:outline-none"
            aria-label="Toggle notification menu"
          >
            <FaBell
              size={24}
              className={`transition-all duration-300 ${isDarkMode ? "text-white" : "text-blue-500"}`}
            />
            {unreadCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center animate-pulse">
                {unreadCount}
              </span>
            )}
          </button>
          {notificationMenuVisible && <NotificationMenu />}
          <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 text-xs bg-gray-800 text-white dark:bg-white dark:text-black px-3 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-50">
            Notifications
          </span>
        </div>

        {/* User Profile Button */}
        <div className="relative group">
          <button
            onClick={toggleUserMenu}
            className="text-white hidden lg:flex rounded-full dark:text-white items-center relative transition-all duration-300 hover:scale-105 focus:outline-none"
          >
            <div className="flex items-center space-x-3 md:space-x-4">
              <div className="relative group">
                {profile ? (
                  <img
                    src={profile}
                    alt="Profile picture"
                    className={`w-10 h-10 rounded-full border-2 shadow-lg transition-all duration-300 ${isDarkMode ? "border-white" : "border-gray-900"
                      }`}
                  />
                ) : (
                  <div
                    className={`w-10 h-10 rounded-full border-2 shadow-lg flex items-center justify-center text-white font-bold text-sm transition-all duration-300 ${isDarkMode ? "bg-red-500 border-white" : "bg-red-500 border-gray-900"
                      }`}
                  >
                    {userName ? userName.slice(0, 2).toUpperCase() : "NA"}
                  </div>
                )}
                <span className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-white rounded-full animate-pulse"></span>
              </div>
              <span
                className={`text-lg md:text-md font-semibold transition-colors duration-300 ${isDarkMode ? "text-white glow" : "text-gray-900"
                  }`}
              >
                {userName}
              </span>
            </div>
          </button>

          {/* User Menu */}
          {userMenu && (
            <div
              ref={userMenuRef}
              className="absolute top-full right-0 mt-4 w-32 bg-white dark:bg-[#071a74f6] border border-gray-200 rounded-lg shadow-lg z-50 transition-all duration-200 ease-in-out overflow-hidden"
            >
              <ul className="text-gray-700 dark:text-gray-200 dark:shadow-custom-dark divide-y divide-gray-200 dark:divide-gray-700">
                <li
                  onClick={navigation}
                  className="py-3 px-4 cursor-pointer hover:bg-gray-100 hover:dark:bg-purple-700 transition-colors duration-200"
                >
                  Profile
                </li>
                <li
                  onClick={handleLogout}
                  className="py-3 px-4 cursor-pointer hover:bg-gray-100 hover:dark:bg-purple-700 transition-colors duration-200"
                >
                  Logout
                </li>
              </ul>
            </div>
          )}

          <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 text-xs bg-gray-800 text-white dark:bg-white dark:text-black px-3 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-50">
            Profile
          </span>
        </div>
      </div>

      <div className="flex-grow mx-2 md:mx-14 lg:pl-20 order-3 md:order-2 w-full md:w-auto mt-4 md:mt-0">
        <div className="relative flex items-center bg-gray-100 dark:bg-[#071a74f6] rounded-md w-full md:w-[75%]">
          <CgSearch className={`absolute left-3 ${isDarkMode ? "dark:text-white" : "text-custom-gray"}`} size={24} />
          <input
            disabled={isSearching}
            type="text"
            id='orderId'
            value={orderIdInput}
            onChange={handleInputChange}
            onKeyDown={handleSearchKeyDown}
            placeholder="Search with Order ID"
            className={`font-sans bg-gray-200 dark:bg-[#071a74f6] w-full h-[40px] border-0 outline-none rounded-[10px] pl-[50px] pr-[10px] bg-opacity-70 text-[12px] md:text-[22px] ${isDarkMode ? "placeholder-white" : "placeholder-custom-gray"}  ${isSearching ? 'cursor-not-allowed opacity-50' : ''} font-san dark:text-white`}
          />
          {isSearching && <div className="absolute right-4 animate-spin">🔄</div>}
        </div>
      </div>
    </div>
  );
};
export default NavBar;



// <div className="px-2 sm:px-4 py-2 md:py-0 relative bg-transparent">
//       {/* Main Row: Logo, Menu, Search (desktop only), and Icons */}
//       <div className="flex items-center justify-between w-full">
//         {/* Left Section: Logo and Menu */}
//         <div className="flex items-center">
//           <Link to="/dashboard">
//             <div className="flex items-center cursor-pointer pl-0 md:pl-0">
//               <img
//                 src="/assets/images/logo1.png"
//                 alt="Logo"
//                 className="w-[60px] h-[40px] sm:w-[120px] sm:h-[50px] lg:w-[190px] lg:h-[100px]"
//               />
//             </div>
//           </Link>
//           <button
//             onClick={() => setIsToggleSidebar(!isToggleSidebar)}
//             className="ml-7 md:ml-10 text-blue-500 dark:text-blue-400"
//           >
//             {isToggleSidebar === false ? <MdMenuOpen size={20} className="w-8 h-8 sm:w-10 sm:h-10" /> : <MdOutlineMenu size={20} className="w-8 h-8 sm:w-10 sm:h-10" />}
//           </button>
//         </div>

//         {/* Middle Section: Search Bar (hidden on mobile) */}
//         <div className="hidden md:flex flex-grow mx-2 md:mx-14 lg:pl-20 order-3 md:order-2 w-full md:w-auto mt-4 md:mt-0">
//           <div className="relative flex items-center bg-gray-100 dark:bg-[#071a74f6] rounded-md w-full md:w-[75%]">
//             <CgSearch className={`absolute left-3 ${isDarkMode ? "dark:text-white" : "text-custom-gray"}`} size={24} />
//             <input
//               disabled={isSearching}
//               type="text"
//               id='orderId'
//               value={orderIdInput}
//               onChange={handleInputChange}
//               onKeyDown={handleSearchKeyDown}
//               placeholder="Search with Order ID"
//               className={`font-sans bg-gray-200 dark:bg-[#071a74f6] w-full h-[40px] border-0 outline-none rounded-[10px] pl-[50px] pr-[10px] bg-opacity-70 text-[12px] md:text-[22px] ${isDarkMode ? "placeholder-white" : "placeholder-custom-gray"} ${isSearching ? 'cursor-not-allowed opacity-50' : ''} font-san dark:text-white`}
//             />
//             {isSearching && <div className="absolute right-4 animate-spin">🔄</div>}
//           </div>
//         </div>

//         {/* Right Section: All Icons in a Line */}
//         <div className="flex items-center space-x-1 lg:space-x-8 lg:pr-12 pr-3 order-2 md:order-3 relative">
//           {/* B2B/B2C Toggle */}
//           <div className="relative group">
//             <div className="relative">
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="60"
//                 height="32"
//                 viewBox="0 0 60 32"
//                 onClick={switchToB2B}
//                 className="cursor-pointer transition-all duration-300 hover:scale-105 filter hover:drop-shadow-lg"
//               >
//                 <defs>
//                   <linearGradient id="onGradient" x1="0%" y1="0%" x2="100%" y2="0%">
//                     <stop offset="0%" style={{ stopColor: '#3B82F6', stopOpacity: 1 }} />
//                     <stop offset="100%" style={{ stopColor: '#1D4ED8', stopOpacity: 1 }} />
//                   </linearGradient>
//                   <linearGradient id="offGradient" x1="0%" y1="0%" x2="100%" y2="0%">
//                     <stop offset="0%" style={{ stopColor: '#9CA3AF', stopOpacity: 1 }} />
//                     <stop offset="100%" style={{ stopColor: '#6B7280', stopOpacity: 1 }} />
//                   </linearGradient>
//                 </defs>
//                 <rect
//                   x="2"
//                   y="2"
//                   rx="14"
//                   ry="14"
//                   width="56"
//                   height="28"
//                   fill={isB2BMode ? "url(#onGradient)" : "#E5E7EB"}
//                   className="transition-all duration-300"
//                 />
//                 {!isB2BMode && (
//                   <text
//                     x="42"
//                     y="17"
//                     textAnchor="middle"
//                     dominantBaseline="middle"
//                     className="font-bold pointer-events-none select-none"
//                     style={{ fontSize: '10px', fontFamily: 'system-ui', fill: '#60A5FA' }}
//                   >
//                     B2C
//                   </text>
//                 )}
//                 {isB2BMode && (
//                   <text
//                     x="18"
//                     y="17"
//                     textAnchor="middle"
//                     dominantBaseline="middle"
//                     className="fill-white font-bold pointer-events-none select-none"
//                     style={{ fontSize: '10px', fontFamily: 'system-ui' }}
//                   >
//                     B2B
//                   </text>
//                 )}
//                 <circle
//                   cx={isB2BMode ? "44" : "16"}
//                   cy="16"
//                   r="11"
//                   className="fill-white transition-all duration-300 filter drop-shadow-md"
//                 />
//                 <circle
//                   cx={isB2BMode ? "44" : "16"}
//                   cy="16"
//                   r="8"
//                   className="fill-white transition-all duration-300"
//                 />
//               </svg>
//             </div>
//             <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 text-xs bg-gray-800 text-white dark:bg-white dark:text-black px-3 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-50">
//               {isB2BMode ? "Switch to B2C" : "Switch to B2B"}
//             </span>
//           </div>

//           {/* Theme Toggle */}
//           <div className="relative group">
//             <button
//               onClick={toggleTheme}
//               className="w-10 h-10 flex items-center justify-center rounded-full transition-all duration-300 hover:bg-gray-100 dark:hover:bg-gray-700 hover:scale-105 focus:outline-none"
//             >
//               {isDarkMode ?
//                 <CiLight size={24} className="text-white transition-colors duration-300" /> :
//                 <FaMoon size={24} className="text-blue-500 transition-colors duration-300" />
//               }
//             </button>
//             <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 text-xs bg-gray-800 text-white dark:bg-white dark:text-black px-3 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-50">
//               {isDarkMode ? "Light Mode" : "Dark Mode"}
//             </span>
//           </div>

//           {/* Wallet Button */}
//           <div className="relative group">
//             <button
//               onClick={toggleWalletMenu}
//               className="w-10 h-10 flex items-center justify-center rounded-full transition-all duration-300 hover:bg-gray-100 dark:hover:bg-gray-700 hover:scale-105 focus:outline-none"
//               aria-label="Toggle wallet menu"
//             >
//               <FaWallet size={24} className={`transition-colors duration-300 ${isDarkMode ? "text-white" : "text-blue-500"}`} />
//             </button>

//             {walletMenuVisible && (
//               <div
//                 ref={walletMenuRef}
//                 className="absolute right-0 mt-4 w-56 bg-white dark:bg-[#071a74f6] border border-gray-200 rounded-lg shadow-lg z-50 transition-all duration-200 ease-in-out overflow-hidden"
//               >
//                 <ul className="text-gray-700 dark:text-gray-200 dark:shadow-custom-dark divide-y divide-gray-200 dark:divide-gray-700">
//                   <li className="py-2 px-4 cursor-default flex items-center justify-between">
//                     <span>Balance</span>
//                     {role !== "admin" ? (
//                       <span className="font-semibold">₹ {currentBalanace}</span>
//                     ) : (
//                       <span className="font-semibold">₹ {totalAmount}</span>
//                     )}
//                   </li>
//                   <li
//                     className="py-2 px-4 cursor-pointer hover:bg-gray-100 hover:dark:bg-purple-700 transition-colors duration-200 flex items-center justify-between"
//                     onClick={goToTopUp}
//                   >
//                     <span>Top-Up</span>
//                     <span className="text-gray-400">|</span>
//                   </li>
//                 </ul>
//               </div>
//             )}
//             <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 text-xs bg-gray-800 text-white dark:bg-white dark:text-black px-3 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-50">
//               Wallet
//             </span>
//           </div>

//           {/* Notification Button */}
//           <div className="relative group">
//             <button
//               onClick={toggleNotificationMenu}
//               className="w-10 h-10 flex items-center justify-center rounded-full transition-all duration-300 hover:bg-gray-100 dark:hover:bg-gray-700 hover:scale-105 focus:outline-none"
//               aria-label="Toggle notification menu"
//             >
//               <FaBell
//                 size={24}
//                 className={`transition-all duration-300 ${isDarkMode ? "text-white" : "text-blue-500"}`}
//               />
//               {unreadCount > 0 && (
//                 <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center animate-pulse">
//                   {unreadCount}
//                 </span>
//               )}
//             </button>
//             {notificationMenuVisible && <NotificationMenu />}
//             <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 text-xs bg-gray-800 text-white dark:bg-white dark:text-black px-3 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-50">
//               Notifications
//             </span>
//           </div>

//           {/* User Profile Button */}
//           <div className="relative group">
//             <button
//               onClick={toggleUserMenu}
//               className="text-white hidden lg:flex rounded-full dark:text-white items-center relative transition-all duration-300 hover:scale-105 focus:outline-none"
//             >
//               <div className="flex items-center space-x-3 md:space-x-4">
//                 <div className="relative group">
//                   {profile ? (
//                     <img
//                       src={profile}
//                       alt="Profile picture"
//                       className={`w-10 h-10 rounded-full border-2 shadow-lg transition-all duration-300 ${isDarkMode ? "border-white" : "border-gray-900"}`}
//                     />
//                   ) : (
//                     <div
//                       className={`w-10 h-10 rounded-full border-2 shadow-lg flex items-center justify-center text-white font-bold text-sm transition-all duration-300 ${isDarkMode ? "bg-red-500 border-white" : "bg-red-500 border-gray-900"}`}
//                     >
//                       {userName ? userName.slice(0, 2).toUpperCase() : "NA"}
//                     </div>
//                   )}
//                   <span className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-white rounded-full animate-pulse"></span>
//                 </div>
//                 <span
//                   className={`text-lg md:text-md font-semibold transition-colors duration-300 ${isDarkMode ? "text-white glow" : "text-gray-900"}`}
//                 >
//                   {userName}
//                 </span>
//               </div>
//             </button>

//             {userMenu && (
//               <div
//                 ref={userMenuRef}
//                 className="absolute top-full right-0 mt-4 w-32 bg-white dark:bg-[#071a74f6] border border-gray-200 rounded-lg shadow-lg z-50 transition-all duration-200 ease-in-out overflow-hidden"
//               >
//                 <ul className="text-gray-700 dark:text-gray-200 dark:shadow-custom-dark divide-y divide-gray-200 dark:divide-gray-700">
//                   <li
//                     onClick={navigation}
//                     className="py-3 px-4 cursor-pointer hover:bg-gray-100 hover:dark:bg-purple-700 transition-colors duration-200"
//                   >
//                     Profile
//                   </li>
//                   <li
//                     onClick={handleLogout}
//                     className="py-3 px-4 cursor-pointer hover:bg-gray-100 hover:dark:bg-purple-700 transition-colors duration-200"
//                   >
//                     Logout
//                   </li>
//                 </ul>
//               </div>
//             )}

//             <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 text-xs bg-gray-800 text-white dark:bg-white dark:text-black px-3 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-50">
//               Profile
//             </span>
//           </div>
//         </div>
//       </div>

//       {/* Mobile Search Bar - Shows only on mobile screens below all icons */}
//       <div className="md:hidden flex-grow mx-2 order-3 w-full mt-4">
//         <div className="relative flex items-center bg-gray-100 dark:bg-[#071a74f6] rounded-md w-full">
//           <CgSearch className={`absolute left-3 ${isDarkMode ? "dark:text-white" : "text-custom-gray"}`} size={24} />
//           <input
//             disabled={isSearching}
//             type="text"
//             id='orderId'
//             value={orderIdInput}
//             onChange={handleInputChange}
//             onKeyDown={handleSearchKeyDown}
//             placeholder="Search with Order ID"
//             className={`font-sans bg-gray-200 dark:bg-[#071a74f6] w-full h-[40px] border-0 outline-none rounded-[10px] pl-[50px] pr-[10px] bg-opacity-70 text-[12px] md:text-[22px] ${isDarkMode ? "placeholder-white" : "placeholder-custom-gray"} ${isSearching ? 'cursor-not-allowed opacity-50' : ''} font-san dark:text-white`}
//           />
//           {isSearching && <div className="absolute right-4 animate-spin">🔄</div>}
//         </div>
//       </div>
//     </div>